/**
 * @fileoverview GET handler for the "/apps/:app_group_id/uninstall_tracking_apps" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdUninstallTrackingApps } from "./constants";
import type { GetUninstallTrackingAppsParams, UninstallTrackingAppsResult } from "./types";
import { isUninstallTrackingAppsResult } from "./validators";

export const getAppsAppGroupIdUninstallTrackingApps = reactQueryFetcherAdapter(
  appsAppGroupIdUninstallTrackingApps,
  (
    signal: AbortSignal,
    { appGroupId, platforms }: GetUninstallTrackingAppsParams
  ): Promise<UninstallTrackingAppsResult> => {
    const queryParams = new URLSearchParams();
    (platforms ?? []).forEach((platform) => queryParams.append("platforms[]", platform));
    const queryString = queryParams.toString();
    const url = queryString
      ? `/apps/${appGroupId}/uninstall_tracking_apps?${queryString}`
      : `/apps/${appGroupId}/uninstall_tracking_apps`;
    return fetch(url, "GET", {}, { signal });
  },
  isUninstallTrackingAppsResult
);
